<template>
  <div
    class="flex flex-col items-center gap-[2.5vh] text-center text-white px-[4vw] max-w-[min(90vw,36rem)]"
    role="status"
    :aria-busy="registrationBootstrapError ? 'false' : 'true'"
    aria-label="A carregar"
  >
    <div
      v-if="registrationBootstrapError"
      class="w-full rounded-lg border border-red-500/35 bg-red-500/15 px-[2vw] py-[1.25vh] text-left text-red-200"
      style="font-size: clamp(0.65rem, 1.1vw, 1rem);"
      role="alert"
    >
      {{ registrationBootstrapError }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'
import usePlayer from '@/composables/usePlayer'

const { state } = usePlayer()
const { registrationBootstrapError } = toRefs(state)
</script>
